import { useEffect, useRef, useState } from 'react';
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList'
import { Modal } from "react-bootstrap";
import { enumUtil } from '../../../../utils/Enum';
import FormValidator from '../../../../utils/FormValidator';
import isNull from '../../../../utils/NullChecking';
import NotificationHandler from '../../../../utils/NotificationHandler';
import handleAlphabeticCheck from '../../../../utils/HandleAlphabetKeys';
import { Countries } from '../../../../utils/Constants';
import handleNumericCheck from '../../../../utils/HandleNumericKeys';
import { ServerRequestProtectedOCR } from '../../../../utils/ServerDataRequest';
import Loader from '../../../shared/Loader/Loader';

const AddPatientCard = ({ isOpenCardDetail, setIsOpenCardDetail, PatientID, onClose }) => {
    let Card_Modal = {
        email: '',
        name: '',
        account: '',
        expiry: '',
        SecurityCode: '',
        CountryRegion: 'United States',
        PatientID: '',
    }
    let valModal = {}
    let ValidationModal = {
        EmailVal: '',
        EmailFormatVal: '',
        NameVal: '',
        AccountVal: '',
        AccountLenVal: '',
        ExpiryVal: '',
        SecurityCodeVal: '',
        SecurityCodeLenVal: '',
        CountryRegionVal: '',
    }
    const API_URL = enumUtil.controller.PatientPay
    const [is, setIs] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [CardValidationModal, setCardValidationModal] = useState(ValidationModal)
    const [cardDetails, setCardDetails] = useState(Card_Modal);
    const [saveCardDetails, setSaveCardDetails] = useState({
        CountryRegion: 'United States'
    });
    const handleCardChange = (e) => {
        setIs(false)
        let { name, value } = e.target;
        if (name === 'expiry') {
            value = formatExpiryDate(value);
        }
        let modal = { ...cardDetails };
        modal[name] = value;
        setCardDetails(modal)
        for (var property in Card_Modal) {
            if (name === property) {
                saveCardDetails[name] = value
            }
        }
        setSaveCardDetails(saveCardDetails)
    }
    const formatExpiryDate = (input) => {
        let value = input.replace(/\D/g, '');
        if (value.length >= 2) {
            let month = value.substring(0, 2);
            if (parseInt(month) > 12) {
                month = '12';
            } else if (parseInt(month) < 1 && month.length === 2) {
                month = '01';
            }
            if (value.length > 2) {
                let year = value.substring(2, 4);
                value = month + '/' + year;
            } else {
                value = month;
            }
        }
        return value.substring(0, 5);
    };
    const handleSelctData = (selectedData, name, type) => {
        setIs(true)
        let modal = { ...cardDetails };
        let saveModal = { ...saveCardDetails }
        if (type === 'client' && !isNull(selectedData)) {
            modal[name] = selectedData.display
            saveModal[name] = selectedData.value + "";

        } else if (type === 'server' && !isNull(selectedData)) {
            modal[name] = selectedData.display
            saveModal[name] = selectedData.value + "";
        } else {
            modal[name] = ''
            saveModal[name] = ''
        }
        setCardDetails(modal)
        setSaveCardDetails(saveModal)
        return selectedData
    }
    const CardValidation = async () => {
        let ValidationModal = {
            NameVal: FormValidator(
                cardDetails.name,
                enumUtil.enumValidationType.Required,
                'Name',
            ),
            EmailVal: FormValidator(
                cardDetails.email,
                enumUtil.enumValidationType.Required,
                'Email',
            ),
            EmailFormatVal: FormValidator(
                cardDetails.email,
                enumUtil.enumValidationType.Email,
                'Email',
            ),
            AccountVal: FormValidator(
                cardDetails.account,
                enumUtil.enumValidationType.Required,
                'Account Number',
            ),
            AccountLenVal: FormValidator(
                cardDetails.account,
                enumUtil.enumValidationType.Length,
                'Account Number',
                16  // lenght validation for account number, adjust as needed
            ),
            SecurityCodeVal: FormValidator(
                cardDetails.SecurityCode,
                enumUtil.enumValidationType.Required,
                'Security Code'
            ),
            SecurityCodeLenVal: FormValidator(
                cardDetails.SecurityCode,
                enumUtil.enumValidationType.Length,
                'Security Code',
                3
            ),
            CountryRegionVal: FormValidator(
                cardDetails.CountryRegion,
                enumUtil.enumValidationType.Required,
                'Country/Region'
            ),
        }
        await setCardValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const [token, setToken] = useState(null);
    const [ready, setReady] = useState(false); // is token ready
    const hiddenInputRef = useRef(null);
    const [tokenError, setTokenError] = useState(null);
    const iframeRef = useRef(null);

    const generateIframeCss = () => {
        const cssObject = {
            body: {
                margin: '0',
                padding: '0',
                fontFamily: 'Poppins, sans-serif'
            },
            input: {
                appearance: 'auto',
                border: '0.5px solid #D8D8D8',
                borderRadius: '5px',
                color: '#2B2F32',
                fontFamily: 'Poppins, sans-serif',
                fontSize: '13px',
                fontWeight: '400',
                height: '36px',
                padding: '2px 7px',
                transition: 'all 0.3s ease',
                boxSizing: 'border-box',
                width: '100% !important',
                display: 'block',
                marginBottom: '10px'
            },
            'input:focus': {
                boxShadow: 'none',
                borderColor: 'var(--orangeBright) !important',
                outline: 'none',
                backgroundColor: '#fff'
            },
            'input + br': {
                display: 'none'
            },
            select: {
                appearance: 'auto',
                border: '0.5px solid #D8D8D8 !important',
                borderRadius: '5px',
                color: '#2B2F32',
                fontFamily: 'Poppins, sans-serif',
                fontSize: '13px',
                fontWeight: '400',
                height: '36px',
                padding: '2px 7px',
                transition: 'all 0.3s ease',
                boxSizing: 'border-box',
                width: 'calc(50% - 15px) !important',
                marginBottom: '10px',
                backgroundColor: '#fff'
            },
            'select:focus': {
                boxShadow: 'none',
                borderColor: 'var(--orangeBright) !important',
                outline: 'none'
            },
            '#ccexpiryyear': {
                marginLeft: '12px !important'
            },
            label: {
                fontSize: '13px',
                color: '#000000',
                fontFamily: 'Poppins, sans-serif',
                fontWeight: '400',
                marginBottom: '3px'
            }
        };

        let cssString = '';
        for (const selector in cssObject) {
            cssString += selector + '{';
            for (const prop in cssObject[selector]) {
                const cssProp = prop.replace(/([A-Z])/g, '-$1').toLowerCase();
                cssString += cssProp + ':' + cssObject[selector][prop] + ';';
            }
            cssString += '}';
        }
        return encodeURIComponent(cssString);
    };
    const iframeUrl = `https://fts-uat.cardconnect.com/itoke/ajax-tokenizer.html?useexpiry=true&invalidexpiryevent=true&usecvv=true&invalidcvvevent=true&cardinputmaxlength=19&cardnumbernumericonly=true&formatinput=true&css=${generateIframeCss()}`;

    const handlePayNow = async () => {
        // await CardValidation();
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        // if (validation) {
        //     NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
        //     return
        // } else {
        if (isNull(token)) {
            NotificationHandler('Card information is missing', enumUtil.enumtoaster.error)
            return
        } else {
            setIsLoading(true)
            let data = { PatientID: PatientID + "", Token: token }
            // let data = { ...saveCardDetails, PatientID: PatientID + "" }
            ServerRequestProtectedOCR(API_URL + '/SavePaymentDetails', 'post', data).then((response) => {
                setIsLoading(false)
                NotificationHandler("Record Saved Successfully", enumUtil.enumtoaster.success)
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsOpenCardDetail(!isOpenCardDetail)
            })
        }
    }
    const handleClosePopup = () => {
        setIsOpenCardDetail(false)
        onClose()
    }


    useEffect(() => {
        // Listener for messages from iframe
        const handleMessage = (event) => {
            // Only accept messages from CardPointe sandbox
            if (!event.origin.includes("fts-uat.cardconnect.com")) return;

            try {
                const data = JSON.parse(event.data);
                console.log(data);

                if (data.message) {
                    // Store token in hidden input
                    if (hiddenInputRef.current) {
                        hiddenInputRef.current.value = data.message;
                    }
                    setToken(data.message);
                    setReady(true); // token is ready
                    // console.log("Token received:", data.message);
                }
            } catch (err) {
                console.error("Failed to parse token message", err);
            }
        };

        window.addEventListener("message", handleMessage, false);

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []);
    return (
        <Modal show={isOpenCardDetail} onHide={isOpenCardDetail} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_card-detail_popup">
            <Modal.Body>
                {isLoading ? <Loader /> : null}
                {/* <div className="d-flex align-items-center justify-content-between mb-12">
                    <p className="heading dark-clr fs-14">Add Card</p>
                    <i className="icon-x-cros fs-20 dark-clr" onClick={handleClosePopup}></i>
                </div>
                <div className="d-flex flex-column gap-3">
                    <div className={CardValidationModal.EmailVal || CardValidationModal.EmailFormatVal ? "input mb-0 error" : "input mb-0"}>
                        <label className='text'>Email</label>
                        <input type="text"
                            className='form-control'
                            name="email"
                            id="email"
                            value={cardDetails.email}
                            onChange={handleCardChange}
                        />
                        {CardValidationModal.EmailVal}
                        {CardValidationModal.EmailFormatVal}
                    </div>
                    <div className={CardValidationModal.NameVal ? "input mb-0 error" : "input mb-0"}>
                        <label >Cardholder Name</label>
                        <input type="text"
                            className='form-control'
                            name="name"
                            id="name"
                            value={cardDetails.name}
                            onChange={handleCardChange}
                            onKeyPress={handleAlphabeticCheck}
                        />
                        {CardValidationModal.NameVal}
                    </div>
                    <div className={CardValidationModal.AccountVal || CardValidationModal.AccountLenVal ? "input mb-0 error" : "input mb-0"}>
                        <label >Card Number</label>
                        <div className="position-relative card-number-input">
                            <input type="text"
                                className='form-control'
                                name="account"
                                id="account"
                                placeholder='xxxx-xxxx-xxxx-xxxx'
                                value={cardDetails.account}
                                onChange={handleCardChange}
                                maxLength={16}
                            />
                            {CardValidationModal.AccountVal}
                            {CardValidationModal.AccountLenVal}
                            <div className='d-flex gap-5 align-items-center position-absolute translate-middle-y top-50 end-0'>
                                <img src='/assets/images/MasterCard.svg' alt="" />
                                <img src='/assets/images/Visa.svg' alt="" />
                                <img src='/assets/images/AmericanExpress.svg' alt="" />
                                <img src='/assets/images/UnionPay.svg' alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-12">
                        <div className={CardValidationModal.ExpiryVal ? "input mb-0 w-100 error" : "input mb-0 w-100"}>
                            <label >Expiration Date</label>
                            <input type="text"
                                className='form-control'
                                name="expiry"
                                id="expiry"
                                value={cardDetails.expiry}
                                onChange={handleCardChange}
                                placeholder='MM/YY'
                            />
                            {CardValidationModal.ExpiryVal}
                        </div>
                        <div className={CardValidationModal.SecurityCodeVal || CardValidationModal.SecurityCodeLenVal ? "input mb-0 w-100 error" : "input mb-0 w-100"}>
                            <label >Security Code</label>
                            <input type="text"
                                className='form-control'
                                name="SecurityCode"
                                id="SecurityCode"
                                value={cardDetails.SecurityCode}
                                onChange={handleCardChange}
                                onKeyPress={handleNumericCheck}
                                maxLength={3}
                            />
                            {CardValidationModal.SecurityCodeVal}
                            {CardValidationModal.SecurityCodeLenVal}
                        </div>
                    </div>
                    <div className={CardValidationModal.CountryRegionVal ? "input error" : "input"}>
                        <label >Country or Region</label>
                        <SuperSearchList
                            type="client"
                            id='CountryRegion'
                            name='CountryRegion'
                            icon={'Simple'}
                            sup_btn='sup_btn-Inp'
                            sup_inp='superSearchVisitInp'
                            searchValue={cardDetails.CountryRegion}
                            data={Countries}
                            onChange={handleCardChange}
                            getSelectedData={handleSelctData}
                            is={is}
                            inputError={CardValidationModal.CountryRegionVal}
                        />
                        {CardValidationModal.CountryRegionVal}
                    </div>
                </div> */}
                <form
                    // onSubmit={handleSubmit}
                    style={{
                        maxWidth: "450px",
                    }}
                >
                    <iframe
                        id="tokenFrame"
                        name="tokenFrame"
                        // Query params to show expiry + CVV fields
                        src={iframeUrl}
                        frameBorder="0"
                        scrolling="no"
                        width="100%"
                        height="185"
                        title="CardPointe Payment Fields"
                    ></iframe>
                </form>
                {/* <div className="w-100">
                        <div className={`btn btn-orange h-100 py-2 lh-normal w-100 rounded d-flex align-items-center justify-content-center ${token ? '' : 'disabled'}`}
                            onClick={handlePayNow}>Pay Now
                        </div>
                    </div> */}
            </Modal.Body>
            <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={handleClosePopup}>Cancel</button>
                <button className={`btn btn-validate px-10 h-100 ${token ? '' : 'disabled'}`} onClick={handlePayNow}>Save</button>
            </div>
        </Modal >
    )
}
export default AddPatientCard